/** dd/mm/yyyy, as the legacy formatDate produced. */
export function formatDate(date: Date): string {
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  return `${day}/${month}/${date.getFullYear()}`
}

/** Last day of the month the date falls in, pinned to day 5 first so month overflow cannot shift it. */
export function lastDayOfMonth(date: Date): Date {
  const pinned = new Date(date.getTime())
  pinned.setDate(5)
  return new Date(pinned.getFullYear(), pinned.getMonth() + 1, 0)
}
